import type { Hero, RawHero } from '@/models/hero'
import { normalizeHero } from '@/models/hero'
import { normalizeTranslations, type TranslationsMap } from '@/models/translations'

export type RawWpTitle = { rendered: string }

export type RawCptAcf = {
  hero?: RawHero
  excerpt?: unknown
  meta?: unknown
  components?: unknown[] | false
  settings?: Record<string, unknown>
}

export type RawCpt = {
  id: number
  type: string
  slug: string
  relative_url?: string
  date?: string
  modified?: string
  title: RawWpTitle
  excerpt?: RawWpTitle
  featured_media?: number
  meta?: unknown
  seo?: unknown
  acf?: RawCptAcf
  translations?: unknown
}

export type CptModel = {
  id: number
  type: string
  slug: string
  relativeUrl?: string
  date?: string
  modified?: string
  title: string
  media?: number
  translations?: TranslationsMap
  hero?: Hero
  excerpt?: RawCptAcf['excerpt']
  meta?: RawCptAcf['meta']
  seo?: unknown
  components?: RawCptAcf['components']
  settings?: RawCptAcf['settings']

  // generic passthrough for CPT variants
  raw?: RawCpt
}

const cpt = (p: RawCpt): CptModel => ({
  id: p.id,
  type: p.type,
  slug: p.slug,
  relativeUrl: p.relative_url,
  date: p.date,
  modified: p.modified,
  title: p.title.rendered,
  media: p.featured_media || undefined,
  translations: normalizeTranslations(p.translations),
  hero: normalizeHero(p.acf?.hero),
  excerpt: p.acf?.excerpt ?? p.excerpt,
  meta: p.acf?.meta ?? p.meta,
  seo: p.seo,
  components: p.acf?.components,
  settings: p.acf?.settings,

  // keep raw
  raw: p,
})

export default cpt
